<template>
	<div class="w-[100%] justify-center inline-flex items-center gap-4 border border-border-tertiary shadow-xs rounded-full bg-white whitespace-nowrap">
		<button type="button" class="swiper-prev btn btn-secondary" @click="emit('prev')">
			<NuxtIcon name="chevron-left" filled class="text-2xl" />
		</button>
		{{ swiperIndex + 1 }} z {{ loop ? childrenLength : swiperSlides }}
		<button type="button" class="swiper-next btn btn-secondary" @click="emit('next')">
			<NuxtIcon name="chevron-right" filled class="text-2xl" />
		</button>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		uid: string,
		childrenLength: number,
		swiperIndex: number,
		swiperSlides: number,
		loop: boolean,
	}

	interface Emits {
		(e: 'prev' | 'next'): void
	}

	defineProps<Props>();

	const emit = defineEmits<Emits>();
</script>
